/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

export const config = {
  defaultCurrencyName: 'USD',
  noDataSymbol: '--'
};

export enum EnergyOptimizationDayType {
  Active = 0,
  Inactive = 1,
  Mixed = 2,
  Excluded = 3
}

export const arraySeriesDateTimeIndex = 0;
export const arraySeriesValueIndex = 1;
